import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../api";

interface Props {
  count?: number;
  initialQuery?: string;
}

export function Masthead({ count, initialQuery = "" }: Props) {
  const navigate = useNavigate();
  const [q, setQ] = useState(initialQuery);
  const searchRef = useRef<HTMLInputElement>(null);

  // "/" focuses search from anywhere on the page, like every good instrument.
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== "/" || e.metaKey || e.ctrlKey || e.altKey) return;
      const target = e.target as HTMLElement;
      if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return;
      e.preventDefault();
      searchRef.current?.focus();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  return (
    <header className="masthead">
      <h1 className="masthead-title"><Link to="/" className="bare">Transcripts</Link></h1>
      <form
        className="masthead-search"
        role="search"
        onSubmit={(e) => {
          e.preventDefault();
          navigate(`/search?q=${encodeURIComponent(q)}`);
        }}
      >
        <span className="masthead-search-icon">Find</span>
        <input
          ref={searchRef}
          type="search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="a word, a phrase, a name… ( / )"
          aria-label="Search transcripts"
        />
      </form>
      <div className="masthead-meta">
        {count != null && <span className="count num">{count}</span>}
        <button type="button" className="logout" onClick={() => { void logout(); }}>Log out</button>
      </div>
    </header>
  );
}
